<!-- TABLE Ở TRANG ADMIN -->
<nz-layout id="purchase-invoice-today">
  <!-- Phần header -->
  <div class="purchase-invoice-today-header">
    <div class="row p-0 m-0">
      <div class="col-4 p-0 m-0 d-flex align-items-center">
       
      </div>
      <div class="col-4 p-0 m-0 d-flex align-items-center justify-content-center">
        <!-- Chọn thiết bị -->
        <div class="device">
          <div *ngIf="subproject.desktop_template_display && subproject?.style !== 'app'" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'desktop'" (click)="deviceTemp = 'desktop'">
            <span nz-icon [nzType]="'desktop'" nzTheme="outline" data-toggle="tooltip" [title]="'desktop'"
              nz-tooltip nzTooltipTitle="{{'may_tinh' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.tablet_landscape_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'tablet_landscape'" (click)="deviceTemp = 'tablet_landscape'">
            <span nz-icon style="transform: rotate(90deg); scale: 1.2" [nzType]="'tablet'" nzTheme="outline"
              data-toggle="tooltip" [title]="'tablet'" nz-tooltip
              nzTooltipTitle="{{'may_tinh_bang_ngang' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.tablet_portrait_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'tablet_portrait'" (click)="deviceTemp = 'tablet_portrait'">
            <span nz-icon style="scale: 1.2" [nzType]="'tablet'" nzTheme="outline" data-toggle="tooltip"
              [title]="'tablet'" nz-tooltip nzTooltipTitle="{{'may_tinh_bang_doc' | translate}}"
              nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.mobile_landscape_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'mobile_landscape'" (click)="deviceTemp = 'mobile_landscape'">
            <span nz-icon style="transform: rotate(90deg)" [nzType]="'mobile'" nzTheme="outline"
              data-toggle="tooltip" [title]="'mobile'" nz-tooltip
              nzTooltipTitle="{{'dien_thoai_ngang' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.mobile_portrait_template_display" class="icon-field p-2" role="button"
            [class.active]="deviceTemp == 'mobile_portrait'" (click)="deviceTemp = 'mobile_portrait'">
            <span nz-icon [nzType]="'mobile'" nzTheme="outline" data-toggle="tooltip" [title]="'mobile'" nz-tooltip
              nzTooltipTitle="{{'dien_thoai_doc' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
        </div>
      </div>
      <!-- Nút thêm sản phẩm vào frame -->
      <div class="col-4 p-0 m-0 d-flex align-items-center justify-content-end">
        <!-- Chọn ngôn ngữ -->
        <div class="mr-2">
          <app-select-language-config [isAdmin]="true"></app-select-language-config>
        </div>
        <button nzType="primary" class="_btn _btn_add d-flex align-items-center right-all-content mr-2" nz-button
          (click)="handleAddData()">
          {{ 'them_du_lieu' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- Phần table -->
  <div style="margin-top: 16px; height: 500px">
    <nz-table #editRowTable nzBordered [nzData]="listOfData" [nzLoading]="loading" [nzTotal]="total" nzShowSizeChanger
      [nzPageSizeOptions]="[5, 10, 20, 50]" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzScroll]="{ y: '400px' }">
      <thead>
        <tr>
          <th nzWidth="10%">{{'STT' | translate}}</th>
          <th nzWidth="80%">{{'doi_tuong' | translate}}</th>
          <th nzWidth="10%">{{'thao_tac'| translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dataRow of editRowTable.data">
          <td>
            <div class="editable-cell" [hidden]="itemEdit?._id === dataRow._id" (click)="itemEdit = dataRow;">
              {{ dataRow.sort }}
            </div>
            <input [hidden]="itemEdit?._id !== dataRow._id" type="text" nz-input [(ngModel)]="dataRow.sort"
              (blur)="updateOrdinal(dataRow)" />
          </td>

          <td>
            <ng-container *ngIf="dataRow.logo">
              <div class="editable-cell" (click)="chooseItemEdit('logo', dataRow)">
                <strong class="item-name">Logo</strong>:
                <img
                  width="100px" height="100px"
                  [src]="dataRow.logo[deviceTemp + '_src']"
                  alt="logo" class="mb-2 item-img"
                />
              </div>
            </ng-container>

            <ng-container *ngIf="dataRow.title">
              <div class="editable-cell" (click)="chooseItemEdit('title', dataRow)">
                <strong class="item-name">{{ 'tieu_de' | translate }}</strong>
                : {{ dataRow.title['content_' + functionService.languageTempCode] | vhLanguage : 'Tiêu đề' }}
              </div>
            </ng-container>

            <ng-container *ngIf="dataRow.desc">
              <div class="editable-cell" (click)="chooseItemEdit('desc', dataRow)">
                <strong class="item-name">{{ 'mo_ta' | translate }}</strong>
                : {{ dataRow.desc['content_' + functionService.languageTempCode] | vhLanguage : 'Mô tả' }}
              </div>
            </ng-container>

            <ng-container *ngIf="dataRow.image">
              <div class="editable-cell" (click)="chooseItemEdit('image', dataRow)">
                <strong class="item-name">{{ 'hinh_anh' | translate }}</strong>:
                <img
                  width="100px" height="100px"
                  [src]="dataRow.image[deviceTemp + '_src']"
                  alt="image" class="mb-2 item-img"
                />
              </div>
            </ng-container>

            <ng-container *ngIf="dataRow.button">
              <div class="editable-cell" (click)="chooseItemEdit('button', dataRow)">
                <strong class="item-name">{{ 'nut_dieu_huong' | translate }}</strong>
                : {{ dataRow.button['content_' + functionService.languageTempCode] | vhLanguage : 'Nút điều hướng' }}
                <ng-container *ngIf="dataRow.button.icon_enable">
                  <strong class="item-name ml-4">{{ 'bieu_tuong' | translate }}</strong>
                  : <mat-icon *ngIf="dataRow.button.icon_name">{{ dataRow.button.icon_name }}</mat-icon>
                </ng-container>
              </div>
            </ng-container>
          </td>
          <td>
            <a nz-popconfirm [nzPopconfirmTitle]="'ban_co_chac_chan_muon_xoa' | translate"
              (nzOnConfirm)="deleteRow(dataRow._id)"><span nz-icon nzType="delete" class="btn-delete"
                nzTheme="outline"></span></a>
          </td>
        </tr>

        <!-- MODAL EDIT -->
        <nz-modal [(nzVisible)]="isOpenModal" (nzOnCancel)="isOpenModal = false" [nzFooter]="null">
          <ng-container *nzModalContent>
            <ng-container *ngIf="['image', 'logo'].includes(itemEditType)">
              <div *ngIf="!isSharedImg[itemEditType]"
              class="d-flex justify-content-between align-items-center mt-4 mb-2"
              style="gap: 8px;">
                <span>{{'chon_thiet_bi' | translate}}: </span>
                <nz-select style="flex: 1;" [ngModel]="deviceTemp" (ngModelChange)="deviceTemp = $event"
                nzPlaceHolder="{{'chon_thiet_bi' | translate}}" nzAllowClear>
                  <ng-container *ngFor="let d of functionService.devices">
                    <nz-option *ngIf="subproject?.[d.value + '_template_display'] && (d.value !== 'desktop' || subproject?.style == 'website')"
                      [nzValue]="d.value" nzLabel="{{d.label | translate}}"
                    ></nz-option>
                  </ng-container>
                </nz-select>
              </div>
              <div class="image-container">
                <img 
                  nz-image width="100px" height="100px" alt="Lỗi hình ảnh" class="mb-2 mr-2"
                  [nzSrc]="itemEdit[deviceTemp + '_src']"
                  nz-tooltip nzTooltipPlacement="left"
                  [nzTooltipTitle]="itemEdit[deviceTemp + '_src']?.includes(id_subproject) ? tooltipImgInfo : null"
                />
                <div class="image-right">
                  <div style="margin-bottom: 10px; display:flex; align-items: center; gap: 1rem;">
                    <button class="_icon_connect  _icon_connect_active">
                      <!-- icon upload từ thiết bị -->
                      <label for="upload" nz-icon nzType="upload" nzTheme="outline" *ngIf="source == 'device'"></label>
                      <input type="file" id="upload" hidden (change)="onUpload($event, dataRow)">
                      <!-- icon upload từ thư viện -->
                      <span nz-icon nzType="picture" nzTheme="outline" *ngIf="source == 'library'"
                        (click)="openLibrary(dataRow)"></span>
                      <!-- icon ảnh miễn phí -->
                      <span nz-icon nzType="cloud-upload" nzTheme="outline" *ngIf="source == 'free_img'"
                        (click)="openFreeImage(dataRow)"></span>
                      <!-- icon đường dẫn ảnh -->
                      <span nz-popover nzPopoverTitle="{{'duong_dan_anh' | translate}}" nzPopoverTrigger="click"
                        [nzPopoverContent]="contentTemplate" nz-icon nzType="disconnect" nzTheme="outline"
                        *ngIf="source == 'url'">
                      </span>
                      <ng-template #contentTemplate>
                        <input style="width: 260px;" class="input mr-1" type="text" [(ngModel)]="itemEdit.value"
                          [value]="itemEdit.value" placeholder="{{'nhap_duong_dan_lien_ket' | translate}}">
                        <span role="button" class="text-success" (click)="handleLinkImg(dataRow)">{{'ap_dung' |
                          translate}}</span>
                      </ng-template>
                    </button>

                    <button nz-button nzType="primary" (click)="openUploadToServer()"
                    *ngIf="!(itemEdit[deviceTemp + '_src'] || itemEdit.value)?.includes(id_subproject)">
                      {{'chuyen_anh_len_server' | translate}}
                    </button>
                  </div>
                  <div class="d-flex justify-content-between align-items-center my-1">
                    <span>{{ 'anh_dung_chung_cho_cac_thiet_bi' | translate }}</span>
                    <nz-switch [(ngModel)]="isSharedImg.image"></nz-switch>
                  </div>
                  <div style="margin-bottom: 10px;">
                    <nz-select [(ngModel)]="source">
                      <nz-option *ngFor="let source of sources" [nzValue]="source.value"
                        [nzLabel]="source.label | translate"></nz-option>
                    </nz-select>
                  </div>

                  <div *ngIf="source == 'device'">
                    <p class="m-0">{{'nen_anh_tai_len' | translate}}</p>
                    <nz-select style="margin-bottom: 15px" [(ngModel)]="compressType"
                      nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
                      <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
                      <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
                      <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
                    </nz-select>

                    <div style="display:flex; align-items:center; gap: 8px">
                      <mat-form-field *ngIf="compressType == 'custom'">
                        <mat-label>{{'chieu_rong' | translate}}</mat-label>
                        <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
                      </mat-form-field>

                      <mat-form-field *ngIf="compressType == 'custom'">
                        <mat-label>{{'chieu_cao' | translate}}</mat-label>
                        <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- <button *ngIf="isDesignImageSizeValid" nz-tooltip class="w-100" nz-button nzType="primary"
                  [nzTooltipTitle]="'chi_dung_cap_nhat_kich_thuoc_anh_cho_nhung_hinh_anh_dung_yen_khong_co_hieu_ung_truot' | translate"
                  (click)="updateDesignImageSize(itemEdit, dataRow)">
                    {{'cap_nhat_kich_thuoc_anh_theo_kich_thuoc_thiet_ke' | translate}}
                  </button> -->
                </div>
              </div>

              <!-- Cập nhật liên kết -->
              <div *ngIf="itemEditType !== 'image'" class="config-font">
                <!-- type-link -->
                <div class="type-link">
                  <p class="type-link__title">{{'cap_nhat_duong_dan_lien_ket' | translate}}</p>
                  <nz-select class="type-link__select" [(ngModel)]="itemEdit.type_link" [disabled]="true"
                    (ngModelChange)="getBlocksbyPage();updateData(dataRow)" nzPlaceHolder="{{'chon_kieu_lien_ket' | translate}}"
                    allowClear>
                    <nz-option *ngFor="let item of type_link" [nzValue]="item.value" nzLabel="{{item.label | translate}}"></nz-option>
                  </nz-select>
                </div>

                <!-- ĐẾN TRANG -->
                <div class="connect-page" *ngIf="itemEdit.type_link == 'page_link'">
                  <nz-select [(ngModel)]="itemEdit.link" (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                    nzPlaceHolder="{{'chon_trang_lien_ket' | translate}}" allowClear nzShowSearch>
                    <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link" 
                    [nzLabel]="page['name_' + functionService.selectedLanguageCode] || page.name">
                    </nz-option>
                  </nz-select>
                </div>

                <!-- LIÊN KẾT ĐIỀU HƯỚNG -->
                <div class="navigation-link" *ngIf="itemEdit.type_link == 'navigation_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                      [(ngModel)]="itemEdit.link" (blur)="getBlocksbyPage();updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('link')"></span>
                  </ng-template>
                </div>

                <!-- ĐẾN MAIL -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'mailto'">
                  <nz-input-group [nzSuffix]="suffixIconClose"
                  [style.border-color]="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto }) ? 'red' : '#d9d9d9'">
                    <input type="text" nz-input placeholder="viethas.info@gmail.com" [(ngModel)]="itemEdit.mailto"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('mailto')"></span>
                  </ng-template>
                  <p *ngIf="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto })" class="text-danger mt-1 pl-2 lh-base">
                    {{'email_khong_hop_le' | translate}}
                  </p>
                </div>

                <!-- ĐẾN SỐ ĐIỆN THOẠI -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'tel'">
                  <nz-input-group [nzSuffix]="suffixIconClose"
                  [style.border-color]="itemEdit.tel ? 'red' : '#d9d9d9'">
                    <input type="text" nz-input placeholder="0909925354" [(ngModel)]="itemEdit.tel"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('tel')"></span>
                  </ng-template>
                  <p *ngIf="itemEdit.tel" class="text-danger mt-1 pl-2 lh-base">
                    {{'so_dien_thoai_khong_hop_le' | translate}}
                  </p>
                </div>

                <!-- Hành động khi nhấn -->
                <div *ngIf="itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link'" class="mt-3">
                  <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
                  <br />
                  <nz-select id="scroll-select" [(ngModel)]="itemEdit.is_scroll" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let item of clickActionOptions" [nzValue]="item.value" [nzLabel]="item.label | translate"></nz-option>
                  </nz-select>
                </div>

                <!-- CUỘN ĐẾN BLOCK -->
                <ng-container style="width: 100%" *ngIf="(itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link') && itemEdit.is_scroll == 'scroll_to_block'">
                  <nz-select style="margin: 8px 0" [nzPlaceHolder]="'chon_khoi' | translate" [(ngModel)]="itemEdit.scroll_block_id" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let block of blocks_of_page" [nzValue]="block._id" [nzLabel]="block.name | translate"></nz-option>
                  </nz-select>

                  <div class="form-group">
                      <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
                      <input type="number" nz-input class="field-fill" 
                      [(ngModel)]="itemEdit.scroll_distance"
                      (input)="updateData(dataRow)" />
                  </div>
                </ng-container>

                
                <!-- LIÊN KẾT TRANG KHÁC (URL) -->
                <div class="connect-link" *ngIf="itemEdit.type_link == 'hyper_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="itemEdit.hyper_link"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('hyper_link')"></span>
                  </ng-template>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="['title', 'desc', 'button'].includes(itemEditType)">
              <!-- Chọn ngôn ngữ -->
              <div class="mb-3">
                <app-select-language-config [displayLabel]="true" [isAdmin]="true"></app-select-language-config>
              </div>
              <!-- Cập nhật chữ -->
              <div class="config-font" style="margin-bottom: 20px;">
                <p class="title">{{'cap_nhat_noi_dung_hien_thi' | translate}}</p>
                <textarea nz-input class="content" placeholder="{{'noi_dung' | translate}}..."
                  [ngModel]="itemEdit['content_' + functionService.languageTempCode] | vhLanguage : mapType[itemEditType] : data.component"
                  (ngModelChange)="itemEdit['content_' + functionService.languageTempCode] = $event"
                  (blur)="updateContent(dataRow, 'content')" [nzAutosize]="{ minRows: 3, maxRows: 15 }"></textarea>
              </div>
              <ng-container *ngIf="itemEditType == 'button'">
                <!-- Biểu tượng -->
                <div class="d-flex justify-content-between mt-1 mb-3 align-items-center">
                  <p class="title" style="line-height: 1.5; margin: 0">{{'su_dung_bieu_tuong' | translate}}</p>
                  <nz-switch [(ngModel)]="itemEdit.icon_enable"></nz-switch>
                  <div class="d-flex justify-content-between">
                    <mat-icon>{{ itemEdit.icon_name }}</mat-icon>
                    <button nz-button nzType="default" (click)="openDialogChooseIcon()"
                    style="border-radius: 6px; border: 2px solid #333"
                    [disabled]="!itemEdit.icon_enable">
                      {{'thay_doi' | translate}}
                    </button>
                  </div>
                </div>
              </ng-container>
              <!-- Cập nhật liên kết -->
              <div class="config-font">
                <!-- type-link -->
                <div class="type-link">
                  <p class="type-link__title">{{'cap_nhat_duong_dan_lien_ket' | translate}}</p>
                  <nz-select class="type-link__select" [(ngModel)]="itemEdit.type_link" [disabled]="itemEditType !== 'button'"
                    (ngModelChange)="getBlocksbyPage();updateData(dataRow)" nzPlaceHolder="{{'chon_kieu_lien_ket' | translate}}"
                    allowClear>
                    <nz-option *ngFor="let item of type_link" [nzValue]="item.value" nzLabel="{{item.label | translate}}"></nz-option>
                  </nz-select>
                </div>

                <!-- ĐẾN TRANG -->
                <div class="connect-page" *ngIf="itemEdit.type_link == 'page_link'">
                  <nz-select [(ngModel)]="itemEdit.link" (ngModelChange)="getBlocksbyPage();updateData(dataRow)"
                    nzPlaceHolder="{{'chon_trang_lien_ket' | translate}}" allowClear nzShowSearch>
                    <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link || ''"
                    [nzLabel]="page['name_' + functionService.selectedLanguageCode] || page.name">
                    </nz-option>
                  </nz-select>
                </div>

                <!-- LIÊN KẾT ĐIỀU HƯỚNG -->
                <div class="navigation-link" *ngIf="itemEdit.type_link == 'navigation_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                      [(ngModel)]="itemEdit.link" (blur)="getBlocksbyPage();updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('link')"></span>
                  </ng-template>
                </div>

                <!-- ĐẾN MAIL -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'mailto'">
                  <nz-input-group [nzSuffix]="suffixIconClose"
                  [style.border-color]="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto }) ? 'red' : '#d9d9d9'">
                    <input type="text" nz-input placeholder="viethas.info@gmail.com" [(ngModel)]="itemEdit.mailto"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('mailto')"></span>
                  </ng-template>
                  <p *ngIf="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto })" class="text-danger mt-1 pl-2 lh-base">
                    {{'email_khong_hop_le' | translate}}
                  </p>
                </div>

                <!-- ĐẾN SỐ ĐIỆN THOẠI -->
                <div class="mail-link" *ngIf="itemEdit.type_link == 'tel'">
                  <nz-input-group [nzSuffix]="suffixIconClose"
                  [style.border-color]="itemEdit.tel ? 'red' : '#d9d9d9'">
                    <input type="text" nz-input placeholder="0909925354" [(ngModel)]="itemEdit.tel"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('tel')"></span>
                  </ng-template>
                  <p *ngIf="itemEdit.tel" class="text-danger mt-1 pl-2 lh-base">
                    {{'so_dien_thoai_khong_hop_le' | translate}}
                  </p>
                </div>

                <!-- Hành động khi nhấn -->
                <div *ngIf="itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link'" class="mt-3">
                  <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
                  <br />
                  <nz-select id="scroll-select" [(ngModel)]="itemEdit.is_scroll" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let item of clickActionOptions" [nzValue]="item.value" [nzLabel]="item.label | translate"></nz-option>
                  </nz-select>
                </div>

                <!-- CUỘN ĐẾN BLOCK -->
                <ng-container style="width: 100%" *ngIf="(itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link') && itemEdit.is_scroll == 'scroll_to_block'">
                  <nz-select style="margin: 8px 0" [nzPlaceHolder]="'chon_khoi' | translate" [(ngModel)]="itemEdit.scroll_block_id" (ngModelChange)="updateData(dataRow)">
                    <nz-option *ngFor="let block of blocks_of_page" [nzValue]="block._id" [nzLabel]="block.name | translate"></nz-option>
                  </nz-select>

                  <div class="form-group">
                      <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
                      <input type="number" nz-input class="field-fill" 
                      [(ngModel)]="itemEdit.scroll_distance"
                      (input)="updateData(dataRow)" />
                  </div>
                </ng-container>

                <!-- LIÊN KẾT TRANG KHÁC (URL) -->
                <div class="connect-link" *ngIf="itemEdit.type_link == 'hyper_link'">
                  <nz-input-group [nzSuffix]="suffixIconClose">
                    <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="itemEdit.hyper_link"
                      (blur)="updateData(dataRow)" />
                  </nz-input-group>
                  <ng-template #suffixIconClose>
                    <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('hyper_link')"></span>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </nz-modal>

        <!-- Modal Chuyển ảnh lên server -->
        <nz-modal nzTitle="{{ 'chuyen_anh_len_server' | translate}}" [(nzVisible)]="isShowUploadToServer"
          (nzOnCancel)="cancelUploadToServer()" [nzContent]="modalContent" [nzFooter]="modalFooter">
          <ng-template #modalContent>
            <p>{{'nen_anh_tai_len' | translate}}</p>
            <nz-select style="margin-bottom: 15px" [(ngModel)]="compressType"
              nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
              <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
              <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
              <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
            </nz-select>

            <mat-form-field *ngIf="compressType == 'custom'" class="mr-4">
              <mat-label>{{'chieu_rong' | translate}}</mat-label>
              <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
            </mat-form-field>

            <mat-form-field *ngIf="compressType == 'custom'">
              <mat-label>{{'chieu_cao' | translate}}</mat-label>
              <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
            </mat-form-field>

            <div class="d-flex justify-content-between align-items-center mt-2">
              <span>{{ 'anh_dung_chung_cho_cac_thiet_bi' | translate }}</span>
              <nz-switch [(ngModel)]="isSharedImg"></nz-switch>
            </div>
          </ng-template>
          <ng-template #modalFooter>
            <button nz-button nzType="default" (click)="cancelUploadToServer()">{{'khong' | translate}}</button>
            <button nz-button nzType="primary" (click)="okUploadToServer(itemEdit)"
              [nzLoading]="uploadToServerLoading">{{'dong_y' | translate}}</button>
          </ng-template>
        </nz-modal>
      </tbody>
    </nz-table>
  </div>
</nz-layout>

<ng-template #tooltipImgInfo>
  <div class="my-1 img-info">
    <p class="img-info__text">
      {{ 'thu_muc_chua_tep_hinh_anh' | translate }}: 
    </p>
    <p class="img-info__text highlight ml-2">
      {{ getFileInfo(itemEdit[deviceTemp + '_src']).folderPath }}
    </p>
    <p class="img-info__text mt-1">
      {{ 'ten_tep_hinh_anh' | translate }}: 
    </p>
    <p class="img-info__text highlight ml-2">
      {{ getFileInfo(itemEdit[deviceTemp + '_src']).fullFileName }}
    </p>
  </div>
  <button class="w-100 my-1" nz-button nzType="default" style="padding: 4px 6px;"
  (click)="copyLinkImg(itemEdit[deviceTemp + '_src'])">
    {{'nhan_de_sao_chep_duong_dan_anh' | translate}}
  </button>
</ng-template>